import React, { useMemo, useState } from 'react';
import { Flex } from 'antd';
import { t } from 'i18next';
import { Period } from '../../../../api/types';
import Forecast from './Forecast';
import usePeriods from './usePeriods';

interface ReportProps {
  engineId: number,
  briefId: number,
}

export default function Forecasts ({ engineId, briefId }: ReportProps) {
  const { periods } = usePeriods(engineId);

  return (
    <Flex vertical gap={10} className={'report-forecasts'}>
      <Flex gap={'middle'} justify={'space-between'}>
        <div className={'report-forecasts__title'}>
          {t('info.modelPredictions')}
        </div>
      </Flex>
      <Flex>
        {periods.length === 0
          ? <Flex className={'report-forecasts__empty'}>
            {t('info.emptyPredictions')}
          </Flex>
          : <Flex vertical gap={5} style={{width: '100%'}}>
            {periods.map((period: Period) => (
              <Forecast
                period={period}
                briefId={briefId}
              />
            ))}
          </Flex>
        }
      </Flex>
    </Flex>
  );
}
